"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactI18next = require("react-i18next");
var _SkeletonWrapper = _interopRequireDefault(require("../SkeletonWrapper"));
var _Card = _interopRequireDefault(require("../Card"));
var _eventDispatcher = _interopRequireWildcard(require("../../util/eventDispatcher"));
var _popupSlice = require("../../redux/popupSlice");
var _reactRedux = require("react-redux");
var _Payment = require("./Payment.const");
var _PaymentCardStyled = require("./PaymentCardStyled");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var PaymentCardSkeleton = function PaymentCardSkeleton() {
  return /*#__PURE__*/_react.default.createElement(_PaymentCardStyled.CardStyled, null, /*#__PURE__*/_react.default.createElement(_PaymentCardStyled.CardInfoWrapStyled, null, /*#__PURE__*/_react.default.createElement(_PaymentCardStyled.CardInfoStyled, null, /*#__PURE__*/_react.default.createElement(_PaymentCardStyled.CardTypeStyled, null, /*#__PURE__*/_react.default.createElement(_SkeletonWrapper.default, {
    height: 16,
    width: 28
  })), /*#__PURE__*/_react.default.createElement(_PaymentCardStyled.CardDetailsStyled, null, /*#__PURE__*/_react.default.createElement(_PaymentCardStyled.CardDetailsNameWrapStyled, null, /*#__PURE__*/_react.default.createElement(_PaymentCardStyled.CardDetailsNameStyled, null, /*#__PURE__*/_react.default.createElement(_SkeletonWrapper.default, {
    width: 140
  }))), /*#__PURE__*/_react.default.createElement(_PaymentCardStyled.CardExpirationStyled, null, /*#__PURE__*/_react.default.createElement(_SkeletonWrapper.default, {
    width: 100
  })))), /*#__PURE__*/_react.default.createElement(_SkeletonWrapper.default, {
    height: 43,
    width: 170
  })));
};
var PaymentCard = function PaymentCard(_ref) {
  var isDataLoaded = _ref.isDataLoaded,
    details = _ref.details;
  var dispatch = (0, _reactRedux.useDispatch)();
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  var paymentMethodSpecificParams = details.paymentMethodSpecificParams,
    paymentMethod = details.paymentMethod;
  var getSpecificPaymentMethod = function getSpecificPaymentMethod() {
    if (paymentMethod === 'card') return paymentMethodSpecificParams.variant;
    return paymentMethod;
  };
  var card = isDataLoaded ? _Payment.CardTypes[getSpecificPaymentMethod()] : {
    icon: null,
    title: ''
  };
  var LogoComponent = (card === null || card === void 0 ? void 0 : card.icon) || null;
  var methodTitle = (card === null || card === void 0 ? void 0 : card.title) || '';
  return /*#__PURE__*/_react.default.createElement(_Card.default, {
    withBorder: true,
    type: details.paymentMethod
  }, isDataLoaded ? /*#__PURE__*/_react.default.createElement(_PaymentCardStyled.CardStyled, null, /*#__PURE__*/_react.default.createElement(_PaymentCardStyled.CardInfoWrapStyled, null, /*#__PURE__*/_react.default.createElement(_PaymentCardStyled.CardInfoStyled, null, LogoComponent && /*#__PURE__*/_react.default.createElement(_PaymentCardStyled.CardTypeStyled, null, /*#__PURE__*/_react.default.createElement(LogoComponent, null)), /*#__PURE__*/_react.default.createElement(_PaymentCardStyled.CardDetailsStyled, null, /*#__PURE__*/_react.default.createElement(_PaymentCardStyled.CardDetailsNameWrapStyled, null, /*#__PURE__*/_react.default.createElement(_PaymentCardStyled.CardDetailsNameStyled, null, methodTitle), (paymentMethodSpecificParams === null || paymentMethodSpecificParams === void 0 ? void 0 : paymentMethodSpecificParams.lastCardFourDigits) && /*#__PURE__*/_react.default.createElement(_PaymentCardStyled.CardNumberStyled, null, "(**** ", paymentMethodSpecificParams.lastCardFourDigits, ")")), paymentMethod === 'paypal' && /*#__PURE__*/_react.default.createElement(_PaymentCardStyled.HolderNameStyled, null, paymentMethodSpecificParams.holderName), (paymentMethodSpecificParams === null || paymentMethodSpecificParams === void 0 ? void 0 : paymentMethodSpecificParams.cardExpirationDate) && /*#__PURE__*/_react.default.createElement(_PaymentCardStyled.CardExpirationStyled, null, /*#__PURE__*/_react.default.createElement(_PaymentCardStyled.CardExpirationLabel, null, t('Expiry date')), /*#__PURE__*/_react.default.createElement(_PaymentCardStyled.CardExpirationDateStyled, null, paymentMethodSpecificParams.cardExpirationDate)))), /*#__PURE__*/_react.default.createElement(_PaymentCardStyled.CardEditStyled, {
    onClick: function onClick() {
      dispatch((0, _popupSlice.updatePaymentDetailsPopup)({
        isOpen: true,
        initPaymentMethod: details
      }));
      (0, _eventDispatcher.default)(_eventDispatcher.MSSDK_EDIT_PAYMENT_BUTTON_CLICKED, {
        detail: {
          paymentMethod: paymentMethod
        }
      });
    }
  }, t('Edit payment info')))) : /*#__PURE__*/_react.default.createElement(PaymentCardSkeleton, null));
};
PaymentCard.propTypes = {
  details: _propTypes.default.objectOf(_propTypes.default.any),
  isDataLoaded: _propTypes.default.bool
};
PaymentCard.defaultProps = {
  details: {},
  isDataLoaded: true
};
var _default = PaymentCard;
exports.default = _default;